import { use, useEffect, useState } from "react";
import PageHead from "../Head";
import { Provider } from "react-redux";
import Store from "@/redux/store";
import Context from "@/context/Context";
import HeaderStyleTen from "@/components/Header/HeaderStyle-Ten";
import MobileMenu from "@/components/Header/MobileMenu";
import Cart from "@/components/Header/Offcanvas/Cart";
import Pagination from "@/components/Common/Pagination";
import CourseDetails from "../../data/course-details/courseData.json";
import BackToTop from "../backToTop";
import FooterThree from "@/components/Footer/Footer-Three";
import { CountryNames, postData } from "@/Action/api";
import Link from "next/link";
import CourseSidebar from "@/components/Category/FIlter/CourseSidebar";
import CourseSix from "@/components/Category/FIlter/Course-Six";

const Events = () => {
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [Projects, setProjects] = useState(1);
  const [loading, setloading] = useState(true);
  const [filteredData, setFilteredData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [isSelected, setIsSelected] = useState({
    studydestination: [],
    studymonth: [],
    punjababroad: [],
  });

  const fetchData = async (currentPage = 1, q = searchQuery) => {
    setloading(true);
    if (typeof window !== "undefined") {
      const searchParams = new URLSearchParams(window.location.search);
      const studylevel = searchParams.get("studylevel") || [];

      const data = {
        destinations: [...studylevel, ...isSelected?.studydestination]?.filter(
          (item) => item !== null
        ),
        ...(isSelected?.studymonth?.length > 0 && {
          month: isSelected?.studymonth?.filter((item) => item !== null),
        }),
        ...(isSelected?.punjababroad?.length > 0 && {
          country: isSelected?.punjababroad?.filter((item) => item !== null),
        }),
        ...(q && { q }),
      };
      try {
        const navData = await postData(`/get/events`, data);
        setProjects(navData?.data);
        setloading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
        setloading(false);
      }
    }
  };

  useEffect(() => {
    fetchData();

    const handleURLChange = () => fetchData();
    window.addEventListener("popstate", handleURLChange);

    return () => {
      window.removeEventListener("popstate", handleURLChange);
    };
  }, []);

  let getAllCourse = JSON.parse(
    JSON.stringify(CourseDetails.courseDetails.slice(0, 12))
  );
  let getAllCourses = JSON.parse(
    JSON.stringify(CourseDetails.courseDetails.slice(0, 12))
  );
  const gradient1 =
    "linear-gradient(25deg, rgb(14, 20, 46) 50%, rgb(157, 86, 24) 100%)";
  const gradient2 =
    "linear-gradient(25deg, rgba(14, 20, 46, 1) 0%, rgba(16, 24, 113, 1) 100%)";
  const startIndex = (page - 1) * 6;

  const handleClick = (num) => {
    fetchData(num);
    setPage(num);
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const style = {
    background: gradient1,
    transition: "background 0.3s ease", // Optional: adds a smooth transition effect
  };

  useEffect(() => {
    (async () => {
      try {
        const currentMonth = new Date().getMonth() + 1;
        const destination_result = await CountryNames();
        setFilteredData([
          {
            Title: "Select Study Destination",
            Data: destination_result?.res?.data?.map((item) => ({
              ...item,
              checkvalue: "studydestination",
            })),
            name: "studydestination",
          },
          {
            Title: "Select Month",
            Data: [
              {
                id: 1,
                name: "January",
                checkvalue: "studymonth",
              },
              {
                id: 2,
                name: "February",
                checkvalue: "studymonth",
              },
              {
                id: 3,
                name: "March",
                checkvalue: "studymonth",
              },
              {
                id: 4,
                name: "April",
                checkvalue: "studymonth",
              },
              {
                id: 5,
                name: "May",
                checkvalue: "studymonth",
              },
              {
                id: 6,
                name: "June",
                checkvalue: "studymonth",
              },
              {
                id: 7,
                name: "July",
                checkvalue: "studymonth",
              },
              {
                id: 8,
                name: "August",
                checkvalue: "studymonth",
              },
              {
                id: 9,
                name: "September",
                checkvalue: "studymonth",
              },
              {
                id: 10,
                name: "October",
                checkvalue: "studymonth",
              },
              {
                id: 11,
                name: "November",
                checkvalue: "studymonth",
              },
              {
                id: 12,
                name: "December",
                checkvalue: "studymonth",
              },
            ]
              .slice(currentMonth - 1) // Start from the current month
              .concat(
                [...Array(currentMonth - 1)].map((_, index) => ({
                  id: index + 1,
                  name: new Date(0, index).toLocaleString("en-US", {
                    month: "long",
                  }), // Convert month index to month name
                  checkvalue: "studymonth",
                }))
              ),
            name: "studymonth",
          },
          {
            Title: "Select Location",
            Data: [
              {
                id: 1,
                name: "Amritsar",
                region: "Majha",
                migrationTrend: "High",
                checkvalue: "punjababroad",
              },
              {
                id: 2,
                name: "Ludhiana",
                region: "Doaba",
                migrationTrend: "High",
                checkvalue: "punjababroad",
              },
              {
                id: 3,
                name: "Jalandhar",
                region: "Doaba",
                migrationTrend: "High",
                checkvalue: "punjababroad",
              },
              {
                id: 4,
                name: "Patiala",
                region: "Malwa",
                migrationTrend: "Medium",
                checkvalue: "punjababroad",
              },
              {
                id: 5,
                name: "Bathinda",
                region: "Malwa",
                migrationTrend: "Medium",
                checkvalue: "punjababroad",
              },
              {
                id: 6,
                name: "Moga",
                region: "Majha",
                migrationTrend: "Medium",
                checkvalue: "punjababroad",
              },
              {
                id: 7,
                name: "Firozpur",
                region: "Majha",
                migrationTrend: "Low",
                checkvalue: "punjababroad",
              },
              {
                id: 8,
                name: "Hoshiarpur",
                region: "Doaba",
                migrationTrend: "Low",
                checkvalue: "punjababroad",
              },
              {
                id: 9,
                name: "Mohali",
                region: "Malwa",
                migrationTrend: "High",
                checkvalue: "punjababroad",
              },
              {
                id: 10,
                name: "Chandigarh",
                region: "Malwa",
                migrationTrend: "High",
                checkvalue: "punjababroad",
              },
            ],
            name: "punjababroad",
          },
        ]);
      } catch (err) {
        console.error(err);
      }
    })();
  }, []);

  useEffect(() => {
    // setCourse(courseData);
    setTotalPages(Math.ceil(getAllCourse.length / 6));
    setTotalPages(Math.ceil(getAllCourses.length / 6));
  }, [setTotalPages]);
  useEffect(() => {
    let delayDebounceFn;

    delayDebounceFn = setTimeout(async () => {
      fetchData();
    }, 100);

    return () => clearTimeout(delayDebounceFn);
    // eslint-disable-next-line
  }, [isSelected]);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      fetchData(1, searchQuery);
    }, 500);
    return () => clearTimeout(delayDebounceFn);
    // eslint-disable-next-line
  }, [searchQuery]);

  useEffect(() => {
    const delaysearcfun = setTimeout(async () => {
      try {
        fetchData();
      } catch (err) {
        console.error(err);
      }
    }, 100);
    return () => clearTimeout(delaysearcfun);
  }, [isSelected]);

  return (
    <>
      <PageHead title="Events-Immigration Guru's"
        description="Upcoming education fairs, university webinars and counselling sessions from The Immigration Gurus. Meet admissions teams and plan your study abroad." />

      <Provider store={Store}>
        <Context>
          <HeaderStyleTen headerSticky="rbt-sticky" headerType={true} />
          <MobileMenu />
          <Cart />

          <div className="rbt-page-banner-wrapper cursor-pointer">
            <div
              className="rbt-banner-image cursor-pointer"
              style={style}
            ></div>

            <div className="rbt-banner-content">
              <div className="rbt-banner-content-top">
                <div className="container">
                  <div className="row">
                    <div className="col-lg-12">
                      <ul className="page-list">
                        <li className="rbt-breadcrumb-item text-white">
                          <Link href="/">Home</Link>
                        </li>
                        <li>
                          <div className="icon-right">
                            <i className="feather-chevron-right"></i>
                          </div>
                        </li>
                        <li className="rbt-breadcrumb-item active text-white">
                          All Events
                        </li>
                      </ul>
                      <div className=" title-wrapper">
                        <h1 className="title mb--0 text-white">All Events</h1>
                      </div>
                      <p className="description text-white">
                        Explore exclusive events like university fairs, visa
                        workshops, and scholarship webinars to kickstart your
                        study abroad journey. Stay informed and connect with
                        experts to make your dream of studying overseas a
                        reality!
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="rbt-section-overlayping-top rbt-section-gapBottom">
            <div className="container">
              <div className="row row--30 gy-5">
                <div className="col-lg-3 order-2 order-lg-1">
                  <CourseSidebar
                    isSelected={isSelected}
                    setIsSelected={setIsSelected}
                    Data={filteredData}
                    onSearch={setSearchQuery}
                  />
                </div>
                <div
                  className="col-lg-9 order-1 order-lg-2"
                  style={{
                    paddingLeft: "0px",
                    paddingRight: "0px",
            
                  }}
                >
                  <h2 className="title h4 mb--20">
                    Upcoming Events &amp; Webinars
                  </h2>
                  {loading ? (
                    <div
                      className="spinner-border"
                      role="status"
                      style={{
                                display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        textAlign: 'center',
                        height: "100px",
                        width: "100px",
                      }}
                    >
                      <span className="sr-only">Loading...</span>
                    </div>
                  ) : (
                    <CourseSix Data={Projects?.events ?? []} />
                  )}
                </div>
              </div>
              {Projects?.pagination?.totalPages > 0 ? (
                <div className="row">
                  <div className="col-lg-12 mt--60">
                    <Pagination
                      totalPages={Projects?.pagination?.totalPages}
                      pageNumber={Projects?.pagination?.currentPage}
                      handleClick={handleClick}
                    />
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>
          </div>

          <BackToTop />
          <FooterThree />
        </Context>
      </Provider>
    </>
  );
};

export default Events;

export async function getServerSideProps() {
  try {
    const result_data = {
      name: "John Doe",
      country: "USA",
      occupation: "Software Developer",
    };

    return {
      props: {
        result_data,
      },
    };
  } catch (err) {
    console.error("Error:", err);
    return {
      notFound: true,
    };
  }
}
